import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

export const login = (userId, password) =>
  api.post('/login', { userId, password });

export const getFiles = () =>
  api.get('/files');

export const getPreview = (filename) =>
  api.get(`/preview/${encodeURIComponent(filename)}`);

export const predict = (filename) =>
  api.post('/predict', { filename });

export const downloadCsv = (filename) =>
  api.post('/download', { filename }, { responseType: 'blob' });

export default api;
